if (!customElements.get('product-upsell-addon')) {
  customElements.define(
    'product-upsell-addon',
    class ProductUpsellAddon extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.formId = this.dataset.formId;
        this.addonPrice = parseInt(this.dataset.addonPrice || '0', 10);
        this.addonOn = false;
        this.guard = false;

        this.checkbox = this.querySelector('.mb-upsell-addon__input');
        this.addonLabel = this.querySelector('.mb-upsell-addon');
        this.addonInput = this.querySelector('.upsell-addon-variant-id');
        this.addonQtyInput = this.querySelector('.upsell-addon-variant-qty');
        this.singlePriceEl = this.querySelector('.mb-upsell-single__price');

        this.bind();
        this.renderPrices();
      }

      bind() {
        if (this.addonLabel && this.checkbox) {
          this.addonLabel.addEventListener('click', (event) => {
            if (event.target === this.checkbox) return;
            event.preventDefault();
            this.checkbox.checked = !this.checkbox.checked;
            this.onAddonToggle();
          });
          this.checkbox.addEventListener('change', () => this.onAddonToggle());
        }

        var refresh = (event) => {
          if (event && event.data && event.data.sectionId && String(event.data.sectionId) !== String(this.sectionId)) return;
          this.renderPrices();
        };

        document.addEventListener('mb:variant-change', refresh);
        document.addEventListener('mb:abo-updated', refresh);

        var dawnBound = false;
        var bindDawn = () => {
          if (dawnBound || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return dawnBound;
          subscribe(PUB_SUB_EVENTS.variantChange, refresh);
          dawnBound = true;
          return true;
        };

        if (!bindDawn()) {
          var tries = 0;
          var timer = setInterval(() => {
            tries++;
            if (bindDawn() || tries > 40) clearInterval(timer);
          }, 100);
        }

        this.observeCtaPrices();
      }

      isAboOn() {
        var widget = document.querySelector('subscription-widget.mb-abo');
        return !!(widget && widget.querySelector('.mb-switch.on'));
      }

      observeCtaPrices() {
        var product = this.closest('.product') || document;
        product.querySelectorAll('[id="price-' + this.sectionId + '"]').forEach((root) => this.observePriceRoot(root));
      }

      observePriceRoot(root) {
        if (!root || root.dataset.upsellObs) return;
        root.dataset.upsellObs = '1';
        new MutationObserver(() => {
          if (this.guard) return;
          if (this.isAboOn()) return;
          this.renderPrices();
        }).observe(root, { childList: true, subtree: true, characterData: true });
      }

      onAddonToggle() {
        this.addonOn = !!(this.checkbox && this.checkbox.checked);
        if (this.addonLabel) this.addonLabel.classList.toggle('is-on', this.addonOn);
        if (this.addonInput) {
          if (this.addonOn) this.addonInput.removeAttribute('disabled');
          else this.addonInput.setAttribute('disabled', 'disabled');
        }
        if (this.addonQtyInput) {
          if (this.addonOn) this.addonQtyInput.removeAttribute('disabled');
          else this.addonQtyInput.setAttribute('disabled', 'disabled');
        }
        this.renderPrices();
      }

      notifyAboWidget() {
        document.dispatchEvent(new CustomEvent('mb:upsell-change'));
      }

      getVariantSelects() {
        var product = this.closest('.product') || document;
        return (
          product.querySelector('variant-selects[data-section="' + this.sectionId + '"]') ||
          product.querySelector('variant-selects')
        );
      }

      getSelectedVariant() {
        var jsonEl =
          this.getVariantSelects()?.querySelector('[data-selected-variant]') ||
          document.getElementById('SelectedVariantJson-' + this.productId);
        if (!jsonEl) return null;
        try {
          return JSON.parse(jsonEl.textContent);
        } catch (e) {
          return null;
        }
      }

      getBasePriceCents() {
        var variant = this.getSelectedVariant();
        if (!variant) return 0;

        if (this.isAboOn()) {
          var widget = document.querySelector('subscription-widget.mb-abo');
          try {
            var data = JSON.parse(widget.querySelector('.mb-abo-data').textContent);
            var info = data.variants[variant.id];
            if (info && info.allowed) return info.sub;
          } catch (e) {}
        }
        return variant.price;
      }

      formatMoney(cents) {
        if (typeof formatPrice === 'function') return formatPrice(cents);
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }

      ctaPriceRoots() {
        var product = this.closest('.product') || document;
        return product.querySelectorAll('.product-form__submit [id="price-' + this.sectionId + '"]');
      }

      updateCtaGoldClass() {
        this.ctaPriceRoots().forEach((root) => {
          root.querySelectorAll('.price').forEach((priceEl) => {
            priceEl.classList.toggle('price--upsell-total', this.addonOn);
          });
        });
      }

      renderPrices() {
        var base = this.getBasePriceCents();
        if (this.singlePriceEl) this.singlePriceEl.textContent = this.formatMoney(base);
        this.updateCtaGoldClass();

        if (this.isAboOn()) {
          this.notifyAboWidget();
          return;
        }

        var total = base + (this.addonOn ? this.addonPrice : 0);
        this.guard = true;
        this.ctaPriceRoots().forEach((root) => {
          root.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((el) => {
            el.textContent = this.formatMoney(total);
            el.dataset.price = total;
          });
        });
        setTimeout(() => {
          this.guard = false;
        }, 0);
      }
    }
  );
}
